import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://asgmotor.com';
const DEFAULT_IMAGE = `${SITE_URL}/images/og-image.jpg`;

export function SEO({ title, description, path = '', image, type = 'website', schema }) {
    const fullTitle = title ? `${title} | ASG Motor` : 'ASG Motor - Vehículos de Ocasión en Don Benito, Badajoz';
    const fullDescription = description || 'Concesionario de vehículos de ocasión en Don Benito, Badajoz. Coches revisados con garantía propia, financiación a medida y taller propio.';
    const fullUrl = `${SITE_URL}${path}`;
    const fullImage = image || DEFAULT_IMAGE;

    return (
        <Helmet
            title={fullTitle}
            script={schema ? [{ type: 'application/ld+json', innerHTML: JSON.stringify(schema) }] : []}
        >
            <meta name="description" content={fullDescription} />
            <link rel="canonical" href={fullUrl} />

            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={fullDescription} />
            <meta property="og:url" content={fullUrl} />
            <meta property="og:image" content={fullImage} />
            <meta property="og:type" content={type} />
            <meta property="og:locale" content="es_ES" />
            <meta property="og:site_name" content="ASG Motor" />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={fullDescription} />
            <meta name="twitter:image" content={fullImage} />
        </Helmet>
    );
}

// Schema.org para LocalBusiness (usar en Home)
export const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "AutoDealer",
    "name": "ASG Motor",
    "description": "Concesionario de vehículos de ocasión en Don Benito, Badajoz. Coches revisados con garantía propia y financiación a medida.",
    "url": "https://asgmotor.com",
    "telephone": "+34627947622",
    "email": "info@asgmotor.com",
    "address": {
        "@type": "PostalAddress",
        "streetAddress": "Avenida de Córdoba 15",
        "addressLocality": "Don Benito",
        "addressRegion": "Badajoz",
        "postalCode": "06400",
        "addressCountry": "ES"
    },
    "geo": {
        "@type": "GeoCoordinates",
        "latitude": 38.955,
        "longitude": -5.861
    },
    "openingHoursSpecification": [
        {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            "opens": "09:00",
            "closes": "14:00"
        },
        {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            "opens": "16:30",
            "closes": "20:00"
        },
        {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": "Saturday",
            "opens": "10:00",
            "closes": "14:00"
        }
    ],
    "priceRange": "€€",
    "image": "https://asgmotor.com/images/hero-asg-motor.jpg",
    "sameAs": []
};

// Schema.org para Vehicle (usar en ficha)
export function vehicleSchema(vehicle) {
    if (!vehicle) return null;
    return {
        "@context": "https://schema.org",
        "@type": "Car",
        "name": vehicle.custom_title || vehicle.title,
        "brand": { "@type": "Brand", "name": vehicle.brand },
        "model": vehicle.model,
        "vehicleModelDate": vehicle.year ? String(vehicle.year) : undefined,
        "mileageFromOdometer": vehicle.km ? {
            "@type": "QuantitativeValue",
            "value": vehicle.km,
            "unitCode": "KMT"
        } : undefined,
        "fuelType": vehicle.fuel || undefined,
        "vehicleTransmission": vehicle.transmission || undefined,
        "offers": vehicle.price ? {
            "@type": "Offer",
            "price": vehicle.price,
            "priceCurrency": "EUR",
            "availability": vehicle.status === 'available' ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
            "seller": {
                "@type": "AutoDealer",
                "name": "ASG Motor",
                "telephone": "+34627947622"
            }
        } : undefined,
        "image": vehicle.images?.[0] || undefined,
        "url": `https://asgmotor.com/coches/${vehicle.id}`,
        "description": vehicle.description || vehicle.custom_description || undefined,
    };
}
